export class Perfil {
  id!: number;
  descricao!: string;
  podeCadastrarUsuario!: boolean;
  podeCadastrarPerfil!: boolean;
  podeCadastrarFeriado!: boolean;
  podeEditarAgendamento!: boolean;
  podeAcessarSolicitacaoCte!: boolean;
  podeAcessarPlanoManutencao!: boolean;
  podeAcessarSolicitacoesPessoais!: boolean;
}
